import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { AppStore } from "../../stores/AppStore";
import { observable } from "mobx";
import { Alignment, Button, Classes, Dialog, FormGroup, Tag, Tooltip } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IEmpresa, newEmpresa } from "../../model";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { toast } from "react-toastify";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj, sortBy } from "../../utils";
import LoadingModal from "../loading/LoadingModal";
import { DecSefaStore } from "../../stores/dec_sefa/DecSefaStore";


@observer
export default class MensagensDecPage extends React.Component<{}, {}> {

    obs = observable({
        current_page: 1 as number,
        selectEmpresa: newEmpresa() as IEmpresa,
        open_visualiza_mensagem: false as boolean,
        mensagem: [] as any
    })

    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        this.obs.current_page = 1
    }

    handleBuscaTarefasPaged = async (page: number) => {
        this.obs.current_page = page
        DecSefaStore.obs.loading_mensagens = true
        DecSefaStore.handleMensagensPaged(page, this.obs.selectEmpresa.cnpj);
    };

    handleBuscaTarefas = async (empresa) => {
        this.obs.selectEmpresa = empresa
        DecSefaStore.obs.loading_mensagens = true
        DecSefaStore.handleMensagensPaged(1, this.obs.selectEmpresa.cnpj);
    };

    handleAtualizaTarefasPaged = async () => {
        if (this.obs.selectEmpresa.cnpj == "") {
            toast.warning('Selecione uma empresa!', {});
            return;
        }
        DecSefaStore.obs.loading_mensagens = true
        await DecSefaStore.handleMensagensPaged(this.obs.current_page, this.obs.selectEmpresa.cnpj);
    };

    async handleVerMensagem(mensagem: any) {

        this.obs.mensagem = mensagem

        this.obs.open_visualiza_mensagem = true

    }

    async handleVisualizarMensagem(mensagem: any) {

        this.obs.mensagem = mensagem

        this.obs.open_visualiza_mensagem = true

        let res = await DecSefaStore.handleSaveLog(mensagem)

        if (res) {
            await DecSefaStore.handleMensagensPaged(this.obs.current_page, this.obs.selectEmpresa.cnpj);
            await DecSefaStore.handleConsultaMensagens()
        }

    }

    async handleDownloadAnexo(row, mensagem) {

      await DecSefaStore.downloadArquivo(row.id, [row.id])

    }

    async handleDownloadAllAnexo(mensagem) {

      await DecSefaStore.downloadArquivo(mensagem.id_task, mensagem.arquivos)

    }

    handleArquivos() {

        if (this.obs.mensagem.arquivos && this.obs.mensagem.arquivos.length > 0) {

            const formatDownloadAnexo = (cell, row) => {
                return (
                    <>
                        <img src="/images/download.svg" width={20} style={{ cursor: "pointer" }} onClick={(e) => this.handleDownloadAnexo(row, this.obs.mensagem)} />
                    </>
                )
            }

            const formatDownloadAll = (arquivos) => {
                return (
                  <Tooltip content="Clique aqui para baixar todos os arquivos compactados (.zip)">
                    <img src="/images/detalhamento.png" width={20} style={{ cursor: "pointer" }} onClick={(e) => this.handleDownloadAllAnexo(arquivos)} />
                  </Tooltip>
                )
            }

            let arquivos = this.obs.mensagem.arquivos.map(x => {

              return ({
                id: x,
                nome: x
              })

            })
              
            return (<>
                <br/>
                <b>Anexos:</b>

                <BootstrapTable data={arquivos}>
                    <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                    <TableHeaderColumn dataField="nome" width="90%">Nome</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={formatDownloadAnexo} width="10%">{formatDownloadAll(this.obs.mensagem)}</TableHeaderColumn>
                </BootstrapTable>
            </>)

        }

        return (<></>)
    }

    nl2br (str) {

      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br />' + '$2');

    } 

    render() {
        function situacaoFormatter(cell, row) {
            switch (row.situacao) {
                case 0:
                    return <Tag className="tagConfirmacao tagDownload tagProcessando" style={{ width: "50%", textAlign: "center" }}>LEITURA TÁCITA</Tag>
                case 1:
                    return <Tag className="tagConfirmacao tagDownload" style={{ width: "50%", textAlign: "center" }}>LIDO</Tag>
                case 2:
                    return <Tag className="tagConfirmacao tagDownload tagNao" style={{ width: "50%", textAlign: "center" }}>NÃO LIDO</Tag>
                case "LEITURA TÁCITA":
                    return <Tag className="tagConfirmacao tagDownload tagProcessando" style={{ width: "50%", textAlign: "center" }}>{row.situacao}</Tag>
                case "LIDO":
                    return <Tag className="tagConfirmacao tagDownload" style={{ width: "50%", textAlign: "center" }}>{row.situacao}</Tag>
                case "NÃO LIDO":
                    return <Tag className="tagConfirmacao tagDownload tagNao" style={{ width: "50%", textAlign: "center" }}>{row.situacao}</Tag>
                default:
                    return <Tag className="tagConfirmacao tagDownload tagNao" style={{ width: "50%", textAlign: "center" }}>{row.situacao}</Tag>
            }
        }

        const formatVisualizaMensagem = (cell, row) => {
            return (
                <>
                    {row.visualizada ?

                        <img src="/images/envelope.png" width={20} style={{ cursor: "pointer" }} onClick={(e) => this.handleVerMensagem(row)} />

                        :

                        <img src="/images/e-mail.png" width={20} style={{ cursor: "pointer" }} onClick={(e) => this.handleVisualizarMensagem(row)} />

                    }
                </>
            )
        }

        let empresaText = this.obs.selectEmpresa.cnpj != ""
            ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
            : "Selecione uma empresa";

        let itens = DecSefaStore.obs.mensagens_decsefa.map(values => {
            return ({
                titulo: values.notificacoes.titulo,
                tipo: values.notificacoes.tipo,
                situacao: values.notificacoes.situacao,
                mensagem: values.notificacoes.mensagem,
                lido_por: values.notificacoes.lido_por,
                lido_em: values.notificacoes.lido_em,
                id_task: values.notificacoes.id_task,
                id: values.notificacoes.id,
                enviado_em: values.notificacoes.enviado_em,
                arquivos: values.notificacoes.arquivos,
                _id: values.notificacoes._id,
                visualizada: values.notificacoes.visualizada,
            })
        })

        function dateFormatter(cell, row) {
            return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");
        };

        return (
            <>
                <MDBRow>
                    <MDBCol md="4">
                          <FormGroup className="empresaSelect" label="Empresa">
                              <EmpresaSelect
                                  items={EmpresaStore.sortedEmpresas.filter(x => x["filial"] == false)}
                                  itemRenderer={renderEmpresa}
                                  itemPredicate={filterEmpresa}
                                  onItemSelect={(e: IEmpresa) => this.handleBuscaTarefas(e)}
                                  inputProps={{ placeholder: "Filtrar uma empresa" }}
                              >
                                  <Button
                                      text={empresaText}
                                      rightIcon="double-caret-vertical"
                                      alignText={Alignment.LEFT} />
                              </EmpresaSelect>
                          </FormGroup>
                    </MDBCol>
                    <MDBCol md="2">
                        <MDBBtn
                            className="btnDefault btnBuscarNfe mt25"
                            onClick={() => this.handleAtualizaTarefasPaged()}
                        >
                            Buscar
                        </MDBBtn>
                    </MDBCol>
                </MDBRow>
                <div>
                    <BootstrapTable className="TableDefault" ref="table" data={itens}>
                        <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={dateFormatter} dataField="enviado_em" width="10%">Enviado em</TableHeaderColumn>
                        <TableHeaderColumn dataField="tipo" width="30%">Tipo</TableHeaderColumn>
                        <TableHeaderColumn dataField="titulo" width="40%">Título</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={situacaoFormatter} width="20%">Situação</TableHeaderColumn>
                        <TableHeaderColumn dataField="lido_por" width="20%">Lido por</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={dateFormatter} dataField="lido_em" width="15%">Lido em</TableHeaderColumn>
                        <TableHeaderColumn dataFormat={formatVisualizaMensagem} width="5%">LER</TableHeaderColumn>
                    </BootstrapTable>
                </div>

                <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                    <Pager
                        currentPage={this.obs.current_page}
                        totalCount={DecSefaStore.obs.mensagens_length}
                        pageSize={15}
                        onPageChange={page => this.handleBuscaTarefasPaged(page)} />
                </div>

                <Dialog
                    isOpen={this.obs.open_visualiza_mensagem}
                    onClose={(e) => this.obs.open_visualiza_mensagem = false}
                    // title="Mensagem"
                    className="modal-msg"
                >
                  <div style={{maxHeight: 600, overflow: "auto"}}>
                    <div className={Classes.DIALOG_BODY} >

                        <b>{this.obs.mensagem.titulo}</b>
                        <br />
                        <br />
                        <div dangerouslySetInnerHTML={{ __html: this.nl2br(this.obs.mensagem.mensagem) }} style={{ textAlign: "justify" }} />

                        {this.handleArquivos()}

                    </div>
                  </div>
                  <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                      <Button text="Fechar" intent="primary" onClick={() => this.obs.open_visualiza_mensagem = false} />
                  </div>
                </Dialog>

                <LoadingModal open={DecSefaStore.obs.loading_mensagens} onClose={() => DecSefaStore.obs.loading_mensagens = false} title={"Buscando mensagens"} />

            </>
        )
    }
}

